var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"top-panel"},[_c('player-summary',{attrs:{"player":_vm.player}}),_c('div',{staticClass:"right-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }